import { Menu } from '@headlessui/react';
import React from 'react';
import { isElement } from 'react-dom/test-utils';
import { composeClassName } from '@/utils/util_helpers';
import { DropdownMenuButtonProps } from './types';

const DropDownMenuButton: React.FC<DropdownMenuButtonProps> = ({
  className,
  children,
}) => {
  return (
    <Menu.Button
      className={composeClassName(
        'relative flex items-center gap-1',
        className && className
      )}
    >
      {isElement(children)
        ? ({ open }) => {
            return React.Children.map(
              children as unknown as React.ReactElement,
              (child: React.ReactElement) => {
                return {
                  ...child,
                  props: {
                    ...child.props,
                    open,
                  },
                };
              }
            ) as unknown as React.ReactElement;
          }
        : children}
    </Menu.Button>
  );
};

export { DropDownMenuButton };
